import React, { useEffect, useState } from 'react';
import { Box, Stack, Typography, Button } from '@mui/material';
import DashboardNavbar from '../../Components/DashboardNavbar/DashboardNavbar';
import MovingCard from '../../Components/MovingCard';
import { Droppable, DragDropContext } from 'react-beautiful-dnd';
import axios from 'axios';
import SavedModal from '../../Components/Modals/SavedModal';
import { useLocation } from 'react-router-dom';

function RankProjects(props) {

    var { state } = useLocation();
    if(process.env.NODE_ENV === "development"){
        // state['class_id'] = process.env.REACT_APP_TEST_CLASS_ID;
    }
    
    const [projects, setProjects] = useState([]);
    const [rankings, setRankings] = useState([]);
    const [enabled, setEnabled] = useState(true);
    const [open, setOpen] = useState(false);
    
    //saved modal
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const updateList = (items) => {
        setRankings(items.map((item, index) => {
            item.rank = index + 1;
            return item;
        }));
    }

    // onDragEnd exports a destination and a source object
    const handleDragEnd = ({ destination, source }) => {
        if (!destination) {
            console.log("Not dropped in a droppable zone");
        }
        else if (destination.droppableId === source.droppableId) {
            //reordering rankings
            if (destination.droppableId === 'rankings') {
                //save project that was moved
                const selectedProject = rankings[source.index];
                // remove it from the list
                const modifiedRankings = rankings.filter((rank) => rank.project_id !== selectedProject.project_id);
                //insert  the item
                modifiedRankings.splice(destination.index, 0, selectedProject);
                updateList(modifiedRankings);
            }
        }
        //moving from list of projects to ranking
        else if (source.droppableId === 'list' && destination.droppableId === 'rankings') {
            let selectedProject = projects[source.index];
            selectedProject.rank = destination.index + 1;
            setProjects(projects.filter((proj) => proj.project_id !== selectedProject.project_id));
            
            let modifiedRankings = rankings;
            modifiedRankings.splice(destination.index, 0, selectedProject);
            updateList(modifiedRankings);
        }
        //removing from rankings back to list of projects
        else if (source.droppableId === 'rankings' && destination.droppableId === 'list') {
            let selectedProject = rankings[source.index];
            selectedProject.rank = 0;
            updateList(rankings.filter((rank) => rank.project_id !== selectedProject.project_id));

            let modifiedProjects = projects;
            modifiedProjects.splice(destination.index, 0, selectedProject);
            setProjects(modifiedProjects);
        }
    }

    // const handleSearchChange = (event) => {
    //     setProjects(projects.filter(project => project.name.toLowerCase().includes(event.target.value.toLowerCase())));
    // };

    const saveRankings = async () => {
        handleOpen(true);
        axios.post(`${process.env.REACT_APP_API_HOST}/api/ranking/create`,
        {
            ranking: rankings 
        },
        {
            headers: {Authorization: `Bearer ${state.token.access_token}`},
        })
            .then(res => res.data)
            .catch(error => console.log(error)
            );
    }

    const loadPage = async () => {
        // handle co-dependent api calls
        const [proj, ranks] = await Promise.all([
            axios.get(`${process.env.REACT_APP_API_HOST}/api/projects/getAllForClass`, 
            { 
                headers: {Authorization: `Bearer ${state.token.access_token}`},
            })
            .then(res => res.data)
            .then(data => {
                data.map((project) => {
                    project['rank'] = 0;
                })
                return data
            })
            .catch(error => console.log(error)),

            axios.get(`${process.env.REACT_APP_API_HOST}/api/ranking/getRanking`, 
            { 
                headers: {Authorization: `Bearer ${state.token.access_token}`},
            })
            .then(res => res.data)
            .then(data => {return data})
            .catch(error => console.log(error)),
        ])
        
        if(rankings === []){
            console.log("no rankings saved");
            return
        }
        ranks.sort((a, b) => {
            return a.ranking - b.ranking;
        })
        let list = ranks.map((info) => proj.filter((project) => project.project_id === info.project_id)[0])
        list.map((detail, i) => {
            detail.rank = i + 1;
        });
        let included = ranks.map((info) => proj.filter((project) => project.project_id === info.project_id)[0].project_id)

        let remainder = proj.filter((project) => {
            return !included.includes(project.project_id)
        })
        setProjects(remainder);
        setRankings(list);
    }


    useEffect( () => {
        loadPage();
    }, [])

    const containerStyle = {
        width: '46%',
        maxWidth: '800px',
    }

    const listStyle = {
        overflowY: 'auto',
        overflowX: 'hidden',
        height: 600,
        padding: '10px',
    }

    const emptyStyle = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 580,
        borderStyle: 'dashed',
        borderColor: '#999',
        borderRadius: '20px',
        borderWidth: '2px'
    }
    
    return (
        <Box sx={{maxHeight: '100vh'}}>
            <DashboardNavbar userType="student" />
            <DragDropContext onDragEnd={handleDragEnd} >
                <Stack direction='row' justifyContent='space-evenly' sx={{m: 4}}>
                    <Box style={containerStyle}>
                        <Typography variant="h4" style={{marginBlock: 10}}>Rank Projects</Typography>
                        <Typography><br /></Typography>
                        <Droppable droppableId='rankings'>
                            {(provided) => (
                                <div className='RankingBoard' style={listStyle} ref={provided.innerRef} {...provided.droppableProps}>
                                    {rankings.length > 0 ? rankings.map((project, i) => (                                                                
                                            <MovingCard
                                                data={project}
                                                index={i}
                                                key={project.project_id}
                                            />
                                        ))
                                    : 
                                    <Box style={emptyStyle}>
                                        <Typography>Drag a project here to rank it</Typography>
                                    </Box>
                                    }
                                    {provided.placeholder}
                                </div>
                            )}
                        </Droppable>
                    </Box>
                    <Box style={containerStyle}>
                        <Typography variant="h4" style={{marginBlock: 10}}>Projects</Typography>
                        <Typography><b>Click</b> a project card to view its details. <b>Drag</b> a project card to rank it.</Typography>
                        <Typography></Typography>
                        <Droppable droppableId='list'>
                            {(provided) => (
                            <div style={listStyle} ref={provided.innerRef} {...provided.droppableProps}>
                                {projects.length > 0 ? projects.map((project, i) => (
                                    <MovingCard 
                                        index={i} 
                                        data={project} 
                                        key={project.project_id}
                                    />
                                ))
                                : 
                                <Box style={{...emptyStyle, border: 'none'}}>
                                    <Typography>There are no more projects to rank</Typography>
                                </Box>}
                                {/* makes a place for the new droppable to be dropped */}
                                {provided.placeholder}
                            </div>
                            )}
                        </Droppable>
                    </Box>
                </Stack>
            </DragDropContext>

            {/* Footer of page with note and save button */}
            <Stack alignItems='center' sx={{m: 3}} gap={2}>
                <Typography>
                    Note: On the due date,
                    your last saved ranking
                    is the accepted version.
                </Typography>
                {enabled && 
                    <Button onClick={saveRankings} variant='contained' sx={{backgroundColor: "#FFC904"}}>Save Project Rankings</Button>
                }
                <SavedModal open={open} handleClose={handleClose} text={'Your rankings have been saved'}/>
            </Stack>
        </Box>
    );
}

export default RankProjects;
